import { LoginOutlined, ProfileOutlined,DatabaseOutlined,IdcardOutlined,WalletOutlined,BankOutlined,SafetyCertificateOutlined, TeamOutlined, FrownOutlined, CustomerServiceOutlined, FileTextOutlined } from '@ant-design/icons';

// icons
const icons = {
  LoginOutlined,
  ProfileOutlined,
  TeamOutlined,
  FrownOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  IdcardOutlined,
  SafetyCertificateOutlined,
  WalletOutlined, 
  DatabaseOutlined
};

const authentication = {
  id: 'authentication',
  title: 'STACKING',
  type: 'group',
  children: [
    {
      id: 'login',
      title: 'Login',
      type: 'item',
      url: '/login',
      icon: icons.LoginOutlined
    },
    // {
    //   id: 'register',
    //   title: 'register',
    //   type: 'item',
    //   url: '/add-subadmin',
    //   icon: icons.ProfileOutlined
    // },
    {
  id: 'withdrawel',
  title: 'Withdrawal',
  type: 'collapse',
  icon: icons.ProfileOutlined,
  children: [
    {
      id: 'withdraw',
      title: 'Withdraw aprovel',
      type: 'item',
      url: '/withdrawel/withdraw',
      icon: icons.ProfileOutlined,
      adminOnly: true
    },
    {
      id: 'withdrawpending',
      title: 'Withdraw Pending',
      type: 'item',
      url: '/withdrawel/Withdarwpending',
      icon: icons.ProfileOutlined,
      adminOnly: true
    }
  ]
},

{
      id: 'fiatwithdraw',
      title: 'Fiatwithdraw',
      type: 'item',
      url: '/fiatwithdraw',
      icon: icons.ProfileOutlined,
      adminOnly: true
    },


     {
      id: 'admins',
      title: 'Admin',
      type: 'item',
      url: '/admins',
      icon: icons.ProfileOutlined,
      adminOnly: true
    },
    {
      id: 'ticket',
      title: 'Ticket',
      type: 'item',
      url: '/ticket',
      icon: icons.CustomerServiceOutlined,
      permissionKey: 'ticket'
    },
    {
      id: 'complaints',
      title: 'Complaints',
      type: 'collapse',
      icon: icons.FrownOutlined,
      children: [
        {
          id: 'list',
          title: 'List',
          type: 'item',
          url: '/complaints/list',
          icon: icons.FileTextOutlined,
          permissionKey: 'complaintsList'
        },
        {
          id: 'report',
          title: 'Report',
          type: 'item',
          url: '/complaints',
          icon: icons.FileTextOutlined,
          permissionKey: 'complaintsReport'
        }
      ]
    },

    {
      id: 'Stake',
      title: 'Stake',
      type: 'collapse',
      icon: icons.DatabaseOutlined,
      children: [
          {
            id: 'users',
            title: 'New Kait Users',
            type: 'item',
            url: '/users',
            icon: icons.TeamOutlined,
            permissionKey: 'newKaitUsers'
          },
        {
          id: 'Stake',
          title: 'Stake',
          type: 'item',
          url: '/stake',
          icon: icons.SafetyCertificateOutlined,
          permissionKey: 'stake'
        },
         {
            id: 'kyc',
            title: 'New Uesrs Kyc',
            type: 'item',
            url: '/kyc',
            icon: icons.IdcardOutlined,
            permissionKey: 'newUsersKyc'
          },
         {
          id: 'incomewallet',
          title: 'New Users Income Wallet',
          type: 'item',
          url: '/incomewallet',
          icon: icons.BankOutlined,
          permissionKey: 'newUsersIncomeWallet'
        },
         {
          id: 'kaitwallet',
          title: 'New Users Kait Wallet',
          type: 'item',
          url: '/kaitwallet',
          icon: icons.BankOutlined,
          permissionKey: 'newUsersKaitWallet'
        },
        {
          id: 'ros_wallet',
          title: 'New Users Ros Wallet',
          type: 'item',
          url: '/roswallet',
          icon: icons.BankOutlined,
          permissionKey: 'newUsersRosWallet'
        },
        {
          id: 'ReStake',
          title: 'ReStack',
          type: 'item',
          url: '/restake',
          icon: icons.BankOutlined,
          permissionKey: 'newUsersRosWallet'
        },
      ]
    },
    {
      id: 'New Report',
      title: 'New Report',
      type: 'collapse',
      icon: icons.DatabaseOutlined,
      children: [
         {
          id: 'stakereport',
          title: 'Stake Report',
          type: 'item',
          url: '/stakereport',
          icon: icons.BankOutlined,
          permissionKey: 'stakeReport'
        }
      ]
    },
    {
      id: 'Report',
      title: 'Old Report',
      type: 'collapse',
      icon: icons.DatabaseOutlined,
      children: [
         {
          id: 'withdrawreport',
          title: 'Withdraw Report',
          type: 'item',
          url: '/withdrawreport',
          icon: icons.BankOutlined,
          permissionKey: 'withdrawReport'
        },
        {
          id: 'levelincomereport',
          title: 'LevelIncome Report',
          type: 'item',
          url: '/levelincomereport',
          icon: icons.BankOutlined,
          permissionKey: 'levelIncomeReport'
        },
        {
          id: 'Transactionreport',
          title: 'Transactiion Report',
          type: 'item',
          url: '/transactionreport',
          icon: icons.BankOutlined,
          permissionKey: 'transactionReport'
        },
        {
          id: 'StackOverallreport',
          title: 'Stack Over All Report',
          type: 'item',
          url: '/stackoverallreport',
          icon: icons.BankOutlined,
          permissionKey: 'stackOverallReport'
        }
      ]
    },
  ]
};

export default authentication;